import React from "react";
import PropTypes from "prop-types";
import { Navigate, Outlet } from "react-router-dom";
import { routeNames } from "../../consts/routesNames";
import { useAuth } from "../../auth/hooks/usePermissions";

function RequireAdmin({ fallbackPath, children }) {
  const { isAuthenticated, isAdmin } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to={routeNames.LOGIN} replace />;
  }

  if (!isAdmin) {
    return <Navigate to={fallbackPath} replace />;
  }

  return children ?? <Outlet />;
}

RequireAdmin.propTypes = {
  fallbackPath: PropTypes.string,
  children: PropTypes.node,
};

RequireAdmin.defaultProps = {
  fallbackPath: routeNames.HOME,
  children: null,
};

export default RequireAdmin;
